/* global femcare */

/**
 * Video Control Functions
 * Player management and global controls
 */

/**
 * Pause all active video players
 */
femcare.video.pauseAllVideos = function () {
    if (this.activePlayers && this.activePlayers.length > 0) {
        this.activePlayers.forEach(player => {
            try {
                if (player && player.getState() === 'playing') {
                    player.pause();
                }
            } catch (error) {
                console.warn('Error pausing player:', error);
            }
        });
    }
};

/**
 * Remove player from active list
 */
femcare.video.removePlayerFromActive = function (player) {
    if (this.activePlayers) {
        const index = this.activePlayers.indexOf(player);
        if (index > -1) {
            this.activePlayers.splice(index, 1);
        }
    }
};

/**
 * Cleanup modal videos
 * - Clears modal container
 * - Removes/destroys any modal JW Players from activePlayers
 */
femcare.video.cleanupModalVideos = function () {
    const container = document.querySelector('.modal--video .video-player-parent');

    // Destroy and remove all modal players
    if (this.activePlayers && this.activePlayers.length) {
        this.activePlayers = this.activePlayers.filter(player => {
            try {
                if (player && player.__isModal) {
                    if (typeof player.remove === 'function') {
                        player.remove();
                    } else if (typeof player.destroy === 'function') {
                        player.destroy();
                    }
                    return false;
                }
            } catch (e) {
                console.warn('Error cleaning up modal player:', e);
            }
            return true;
        });
    }

    $('.video-inline.video-is-playing, .media-hero__video.video-is-playing').removeClass('video-is-playing');

    if (container) {
        container.innerHTML = '';
    }
};


/**
 * Bind global events
 */
femcare.video.bindGlobalEvents = function () {
    // ESC key to pause videos
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            this.pauseAllVideos();
        }
    });

    // Subscribe to pubsub events
    femcare.shared.pubsub.subscribe('YOUTUBE_VIDEO_PLAYS', this.pauseAllVideos.bind(this));
    femcare.shared.pubsub.subscribe('REQUEST_STOP_ACTIVE_PLAYER', this.pauseAllVideos.bind(this));
};

// Legacy compatibility methods
femcare.video.pauseActivePlayer = function () {
    this.pauseAllVideos();
};

femcare.video.stopActivePlayer = function () {
    this.pauseAllVideos();
};

femcare.video.cleanupVideoModal = function () {
    this.pauseAllVideos();
    this.cleanupModalVideos();
};